import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationComponent {
  @Input() user;
}
